import SearchResults from "../enhancedSearch/HeadSearch/SearchResults";
import searchResultsStyle from "../enhancedSearch/HeadSearch/SearchResults.module.scss";
import { useSearchLogic } from "../../hooks/useSearchLogic";
import styles from "./ModernSearch.module.scss";

const ModernSearch = () => {
  const {
    dropdownRef,
    inputFieldRef,

    isOpen,
    searchValue,
    showSavedOrRecent,
    showSuggestion,
    showSuggestedText,

    suggestionsSelector,
    suggestedText,

    handleInputChange,
    handleFocus,
    handleBlur,
    handleKeyDown,
    suggestionItemClick,
  } = useSearchLogic();

  return (
    <div className={styles.searchContainer}>
      <div className={styles.searchContent}>
        <h1 className={styles.searchTitle}>
          Discover the most trusted clinical <br /> resource in Australia
        </h1>
        <div className={styles.searchWrapper}>
          <i className={`tg-icons-Magnifier ${styles.searchIcon}`} />
          {showSuggestedText && (
            <div className={styles.autocompleteWrapper}>
              <span className={styles.typedText}>{searchValue}</span>
              <span className={styles.suggestedText}>
                {suggestedText.slice(searchValue.length)}
              </span>
            </div>
          )}
          <input
            type="text"
            placeholder="Search"
            className={styles.searchInput}
            value={searchValue}
            onChange={handleInputChange}
            onFocus={handleFocus}
            onBlur={handleBlur}
            onKeyDown={handleKeyDown}
            ref={inputFieldRef}
            autoComplete="off"
          />
        </div>
        {isOpen && (showSavedOrRecent || showSuggestion) && (
          <div className={styles.searchResultsWrapper}>
            <SearchResults
              ref={dropdownRef}
              items={suggestionsSelector}
              handleSelect={suggestionItemClick}
              type="search"
              resultStyle={searchResultsStyle}
              showSavedOrRecent={showSavedOrRecent}
              showSuggestion={showSuggestion}
              searchValue={searchValue}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default ModernSearch;
